
<!--
* A language element with flag
*
* @param {boolean} isActive - Whether the flag is active
* @param {Object} language - Language object with the following keys.
* @param {string} language.isoCode - Country's ISO 3166-1-alpha-2 code
                                     @see https://www.iso.org/obp/ui/#search/code/.
* @param {number} language.id - Id of language item.
-->

<template>
  <!-- list item  -->
  <li class="language_flag__item"
      :language="language"
      v-on:click="onClick()"
      v-bind:class="{ 'language_flag__item--state-active': isActive }">
    <!-- flag class -->
    <span class="language_flag__flag flag-icon"
          v-bind:class="'flag-icon-' + language.countryIsoCode"></span>
  </li>
</template>

<script>
  export default {
    props: [ 'language', 'isActive' ],
    methods: {
      onClick () {
        this.$emit('selected', this.language)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../assets/sass/shared.scss";

  // Library used for svg country flags
  // @see http://flag-icon-css.lip.is
  @import "flag-icon-css/css/flag-icon.css";
  $language-flag-scale: .75;
  $language-flag-width: 57px;
  $language-flag-height: 43px;
  // non active opacity
  $language-flag-opacity: .8;

  .language_flag__item {

    display: flex;
    width: auto;
    align-items: center;
    cursor: pointer;
    flex-wrap: wrap;
    margin: 0 $dims-spacing-small/2;
    opacity: $language-flag-opacity;
    border: 0;

    // bigger and 100% opacity on hover
    &:hover {
       opacity: 1;
      // .language_flag__flag {
      //   width: $language-flag-width;
      //   height: $language-flag-height;
      // }
    }
  }

  // bigger and 100% opacity when active
  .language_flag__item--state-active {
    opacity: 1;
    .language_flag__flag {
      width: $language-flag-width;
      height: $language-flag-height;
    }
  }

  // single flag
  .language_flag__flag {
    width: $language-flag-width * $language-flag-scale;
    height: $language-flag-height * $language-flag-scale;
    background-size: cover;
    border: $flag-border-style;
    transition-property: height, width;
    transition-duration: 350ms;
  }


</style>
